/* REVEAL Presentpapper Studio: verktygsmeny (flikar) enligt mockup */
(function(){
if(window.__rpsUI){window.__rpsUI.scan();return}
var MAP=[['Mönster','gallery'],['Motiv','accMot'],['Färger','accBg'],['Text och namn','accName'],['Bild','accImg'],['Upprepning','accRep'],['Designyta','accCv']];
function init(root){
root.setAttribute('data-ui','1');
var q=function(n){return root.querySelector('[data-r='+n+']')},rail=q('rail');if(!rail)return;
var acc=[].slice.call(root.querySelectorAll('details.acc'));
function sync(){MAP.forEach(function(m,i){var b=rail.children[i],el=q(m[1]);if(b)b.setAttribute('aria-pressed',m[1]!=='gallery'&&!!el&&!!el.open)})}
MAP.forEach(function(m){var b=document.createElement('button');b.type='button';b.className='opt';b.textContent=m[0];
b.addEventListener('click',function(){var el=q(m[1]);if(!el)return;if(m[1]==='gallery'){el.scrollIntoView({behavior:'smooth',block:'center'});return}
acc.forEach(function(d){d.open=(d===el)});el.scrollIntoView({behavior:'smooth',block:'nearest'});sync()});rail.appendChild(b)});
acc.forEach(function(d){d.addEventListener('toggle',function(){if(d.open)acc.forEach(function(o){if(o!==d&&o.open)o.open=false});sync()})});
sync()}
function scan(){document.querySelectorAll('.rps:not([data-ui])').forEach(init)}
window.__rpsUI={scan:scan};document.addEventListener('shopify:section:load',scan);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
})();